import {
  CreatePackageCommand,
  LengthMeasurementUnit,
  PackageDto,
  UpdatePackageCommand,
  WeightMeasurementUnit,
} from '@billing/app/api'
import { PackageFormProfile } from './package-form.profile'

const mapFormValuesToCreateDto = ({
  name,
  height,
  width,
  length,
  lengthUnit,
  weightUnit,
}: PackageFormProfile): CreatePackageCommand => ({
  name,
  height,
  width,
  length,
  lengthUnit: lengthUnit as LengthMeasurementUnit,
  weightUnit: weightUnit as WeightMeasurementUnit,
})

const mapDtoToFormValues = ({
  id,
  name,
  height,
  width,
  length,
  weightUnit,
  lengthUnit,
}: PackageDto): PackageFormProfile => ({
  id,
  name,
  height,
  width,
  length,
  weightUnit,
  lengthUnit,
})

const mapFormValuesToUpdateDto = ({
  id,
  name,
  height,
  width,
  length,
  lengthUnit,
  weightUnit,
}: PackageFormProfile): UpdatePackageCommand => ({
  id: id!,
  name,
  height,
  width,
  length,
  lengthUnit: lengthUnit as LengthMeasurementUnit,
  weightUnit: weightUnit as WeightMeasurementUnit,
})

export const PackageFormMapper = {
  mapFormValuesToCreateDto,
  mapDtoToFormValues,
  mapFormValuesToUpdateDto,
}
